import script from "./CompanyQualification.vue?vue&type=script&lang=ts&setup=true&name=CompanyQualification"
export * from "./CompanyQualification.vue?vue&type=script&lang=ts&setup=true&name=CompanyQualification"

import "./CompanyQualification.vue?vue&type=style&index=0&id=670564c0&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-670564c0"]])

export default __exports__